import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SuperAdminInviteContextType {
  isOpen: boolean;
  selectedBrandId: string | null;
  openInviteDialog: (brandId: string) => void;
  closeInviteDialog: () => void;
}

const SuperAdminInviteContext = createContext<SuperAdminInviteContextType | undefined>(undefined);

export const useSuperAdminInvite = () => {
  const context = useContext(SuperAdminInviteContext);
  if (!context) {
    throw new Error('useSuperAdminInvite must be used within a SuperAdminInviteProvider');
  }
  return context;
};

interface SuperAdminInviteProviderProps {
  children: ReactNode;
}

export const SuperAdminInviteProvider: React.FC<SuperAdminInviteProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedBrandId, setSelectedBrandId] = useState<string | null>(null);

  const openInviteDialog = (brandId: string) => {
    setSelectedBrandId(brandId);
    setIsOpen(true);
  };

  const closeInviteDialog = () => {
    setIsOpen(false);
    setSelectedBrandId(null);
  };

  return (
    <SuperAdminInviteContext.Provider value={{ isOpen, selectedBrandId, openInviteDialog, closeInviteDialog }}>
      {children}
    </SuperAdminInviteContext.Provider>
  );
};
